import { render, staticRenderFns } from "./ReceiverItem.vue?vue&type=template&id=e51c1cbc&scoped=true"
import script from "./ReceiverItem.vue?vue&type=script&lang=ts"
export * from "./ReceiverItem.vue?vue&type=script&lang=ts"
import style0 from "./ReceiverItem.vue?vue&type=style&index=0&id=e51c1cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51c1cbc",
  null
  
)

export default component.exports